import React, { Fragment, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import fontkit from "@pdf-lib/fontkit";
import { PDFDocument } from "pdf-lib";

import { db, storage } from "../../../firebase";

import {
  orderBy,
  where,
  query,
  collection,
  and,
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  getDocs,
  setDoc,
  collectionGroup,
  limit,
} from "firebase/firestore";
import {
  ref,
  getDownloadURL,
  deleteObject,
  listAll,
  uploadBytes,
} from "firebase/storage";
import { Button, Modal } from "react-bootstrap";
import { useAuth } from "../../../context/AuthContext";
import PageTitle from "../../layouts/PageTitle";
import { functions } from "../../../firebase";
import { httpsCallable } from "firebase/functions";
import { usePagination } from "../../../hook/usePagination";
import { useCollection } from "../../../hook/useCollection";
import TicketItem from "./TicketItem";
import { TicketEditForm } from "./TicketEditForm";
import { ExternalRepairForm } from "./ExternalRepairForm";

const TicketList = (props) => {
  const getSignedUrl = httpsCallable(functions, "getSignedUrl");
  const { currentUser } = useAuth();
  const [isLoding, setIsLoading] = useState(false);
  const [isImageLoding, setIsImageLoding] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [edit, setEdit] = useState({});
  const [searchItem, setSearchItem] = useState("");
  const [tickets, setTickets] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileNames, setFilenames] = useState([]);
  const [editSearchSerial, setEditSearchSerial] = useState("");

  // Email modal states
  const [mailModal, setMailModal] = useState(false);
  const [emailList, setEmailList] = useState([]);
  const [selectEmail, setSelectEmail] = useState("");
  const [emailLoading, setEmailLoading] = useState(false);
  const [dataToSend, setDataToSend] = useState({});

  // External repair modal states
  const [externalRepairModal, setExternalRepairModal] = useState(false);
  const [repairTicket, setRepairTicket] = useState(null);
  const externalRepairInputRef = useRef({
    vendor: "",
    sentDate: "",
    details: "",
    notes: "",
    repairStatus: "",
  });

  const searchRef = useRef(null);
  const textRef = useRef(null);

  const [patientData, setPatientData] = useState({
    firstname: "",
    lastname: "",
    refCustomer: "",
    warranty: "",
    hn: "",
    brand: "",
    model: "",
    purchaseDate: "",
  });

  const inputRef = useRef({
    date: "",
    serviceType: "",
    sn: "",
    detail: "",
    accessories: "",
    description: "",
    image: "",
    receiveBy: "",
    serviceStatus: "",
    repairLocation: "",
    serviceDetail: "",
    completionDate: "",
    serviceBy: "",
  });

  const { documents, error } = useCollection("equipments", [
    "serialNumber",
    "asc",
  ]);

  const itemPerPage = 50;

  let QueryFilterConstraint = [];
  let queryRef = query(
    collection(db, "serviceTickets"),
    // orderBy("serviceStatus", "desc"),
    orderBy("serviceOrderNumber", "desc"),
  );

  if (searchItem !== "") {
    QueryFilterConstraint.push(
      where("firstname", ">=", searchItem),
      where("firstname", "<=", searchItem + "\uf8ff"),
    );

    queryRef = query(
      collection(db, "serviceTickets"),
      and(...QueryFilterConstraint),
      // orderBy("serviceStatus", "desc"),
      orderBy("serviceOrderNumber", "desc"),
    );
  }

  const {
    items: serviceTicketsList,
    // isLoading,
    isStart,
    isEnd,
    getPrev,
    getNext,
    totalItems,
    totalPages,
    currentPage,
    goToPage,
  } = usePagination(queryRef, { limit: itemPerPage });

  // console.log("serviceTicketsList", serviceTicketsList);

  const toggle = () => {
    setShowModal(!showModal);
  };

  const handleChange = (name) => (e) => {
    if (name === "image") {
      for (let i = 0; i < e.target.files.length; i++) {
        const f = e.target.files[i];
        setSelectedFiles((prevState) => [...prevState, f]);
        setFilenames((prevState) => [...prevState, f.name]);
      }
    }
    if (name === "sn") {
      setEditSearchSerial(e.target.value);
    }
    inputRef.current[name] = e.target.value;
  };

  const handleProductFound = (productData) => {
    console.log("productData", productData);

    const foundData = {
      firstname: productData.firstname || "",
      lastname: productData.lastname || "",
      refCustomer: productData.refCustomer || "",
      mobile: productData.mobile || "",
      nodeRef: productData.nodeRef || "",
      warranty: productData.warranty || "",
      hn: productData.hn || "",
      brand: productData.brand || "",
      model: productData.model || "",
      purchaseDate: productData.purchaseDate || "",
    };

    setPatientData((prev) => ({
      ...prev,
      ...foundData,
    }));

    inputRef.current = {
      ...inputRef.current,
      ...foundData,
      sn: productData.productSn || inputRef.current.sn || "",
    };

    setEdit((prev) => ({
      ...prev,
      ...foundData,
      sn: productData.productSn || inputRef.current.sn || prev.sn || "",
    }));
  };

  const handleOnEdit = async (id) => {
    const data = serviceTicketsList.find((item) => item.id === id);

    // const ref = collection(db, `equipments/${data.id}`);
    // let queryHandler = query(ref, where("title", "==", "CPAP Image"));

    console.log("edit service ticket data", data);

    // Reset inputRef to prevent value persistence from previous edits
    inputRef.current = {};

    setEditSearchSerial(data.sn || "");
    setEdit(data);
    setShowModal(true);
  };

  const handleOnHide = () => {
    setShowModal(false);

    // Reset all state to prevent persistence
    inputRef.current = {};
    setEditSearchSerial("");
    setSelectedFiles([]);
    setFilenames([]);
  };

  const handleOnDelete = (id, image) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteDoc(doc(db, "serviceTickets", id)).then(() => {
          //delete file
          const storageRef = ref(storage, `serviceImage/${id}`);
          listAll(storageRef).then((res) => {
            const removeRef = res.items.filter((itemRef) =>
              image.includes(itemRef.name),
            );
            removeRef.forEach((res) => {
              const storageRef = ref(storage, `serviceImage/${id}/${res.name}`);
              deleteObject(storageRef, res.name);
            });
          });
          swal(`Poof! Your file has been deleted!`, {
            icon: "success",
          });
        });
      } else {
        swal("Canceled");
      }
    });
  };

  const onSearchChange = () => {
    setSearchItem(searchRef.current.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const docRef = doc(db, "serviceTickets", edit.id);
    const docSnap = await getDoc(docRef);

    const getUpdatedValue = (name, fallback = "") =>
      Object.prototype.hasOwnProperty.call(inputRef.current, name)
        ? inputRef.current[name]
        : edit[name] || fallback;

    const normalizeSearchDate = (value) => {
      if (!value) return value || "";
      if (typeof value !== "string") return value;

      const parsedDate = new Date(value);
      return Number.isNaN(parsedDate.getTime()) ? value : parsedDate;
    };

    let formData = {};
    if (docSnap.exists()) {
      formData = {
        date: "date" in inputRef.current ? inputRef.current.date : edit.date,
        serviceType:
          "serviceType" in inputRef.current
            ? inputRef.current.serviceType
            : edit.serviceType,
        sn: "sn" in inputRef.current ? inputRef.current.sn : edit.sn,
        hn: getUpdatedValue("hn"),
        firstname: getUpdatedValue("firstname"),
        lastname: getUpdatedValue("lastname"),
        refCustomer: getUpdatedValue("refCustomer"),
        mobile: getUpdatedValue("mobile"),
        nodeRef: getUpdatedValue("nodeRef"),
        brand: getUpdatedValue("brand"),
        model: getUpdatedValue("model"),
        purchaseDate: normalizeSearchDate(getUpdatedValue("purchaseDate")),
        warranty: normalizeSearchDate(getUpdatedValue("warranty")),
        accessories:
          "accessories" in inputRef.current
            ? inputRef.current.accessories
            : edit.accessories,
        description:
          "description" in inputRef.current
            ? inputRef.current.description
            : edit.description,
        image: fileNames.length > 0 ? fileNames : edit.image,
        receiveBy:
          "receiveBy" in inputRef.current
            ? inputRef.current.receiveBy
            : edit.receiveBy,
        serviceStatus:
          "serviceStatus" in inputRef.current
            ? inputRef.current.serviceStatus
            : edit.serviceStatus,
        repairLocation:
          "repairLocation" in inputRef.current
            ? inputRef.current.repairLocation
            : edit.repairLocation,
        serviceDetail:
          "serviceDetail" in inputRef.current
            ? inputRef.current.serviceDetail
            : edit.serviceDetail,
        completionDate:
          "completionDate" in inputRef.current
            ? inputRef.current.completionDate
            : edit.completionDate,
        serviceBy:
          "serviceBy" in inputRef.current
            ? inputRef.current.serviceBy
            : edit.serviceBy,
        externalRepairSentDate:
          "externalRepairSentDate" in inputRef.current
            ? inputRef.current.externalRepairSentDate
            : edit.externalRepairSentDate || "",
        amount:
          "amount" in inputRef.current
            ? inputRef.current.amount
            : edit.amount || "",
        note:
          "note" in inputRef.current ? inputRef.current.note : edit.note || "",
        updatedBy: currentUser.displayName,
        updatedAt: new Date(),
      };
      console.log(formData);
    }

    // if (inputRef.current.ticketStatus === "ดำเนินการเสร็จสิ้น") {
    //   //update equiment status : ส่งซ่อม
    //   const eqRef = doc(db, "equipments", edit.equipmentId);
    //   await updateDoc(eqRef, { status: "พร้อมใช้งาน" });
    // }

    await updateDoc(docRef, formData);

    // Update service logs for service ticket changes
    const logUpdatePromises = [];

    // Only update logs if we have the necessary data
    if (edit.hn && edit.sn && edit.ticketId) {
      // Find the product ID if we have the serial number
      const products = tickets; // Assuming products are available in tickets data
      const product = products.find((ticket) => ticket.sn === edit.sn);

      if (product) {
        // Update patient service log
        const patientServiceLogRef = doc(
          db,
          "patients",
          edit.hn,
          "services",
          edit.ticketId,
        );
        logUpdatePromises.push(
          updateDoc(patientServiceLogRef, {
            serviceType: formData.serviceType,
            serviceStatus: formData.serviceStatus,
            updatedAt: new Date(),
            updatedBy: currentUser.displayName,
          }).catch((error) => {
            console.warn(
              `Failed to update patient service log for ${edit.hn}:`,
              error,
            );
          }),
        );

        // Update product service log
        const productServiceLogRef = doc(
          db,
          "products",
          product.id || edit.productId,
          "logs",
          edit.ticketId,
        );
        logUpdatePromises.push(
          updateDoc(productServiceLogRef, {
            serviceType: formData.serviceType,
            serviceStatus: formData.serviceStatus,
            activity: "service", // Keep original activity
            updatedAt: new Date(),
            updatedBy: currentUser.displayName,
          }).catch((error) => {
            console.warn(`Failed to update product service log:`, error);
          }),
        );
      }
    }

    // Execute log updates (don't await to avoid blocking UI)
    if (logUpdatePromises.length > 0) {
      Promise.all(logUpdatePromises)
        .then(() => {
          console.log("Service logs updated successfully");
        })
        .catch((error) => {
          console.warn("Some service log updates failed:", error);
        });
    }

    if (fileNames.length > 0) {
      //upload image
      const promises = [];
      selectedFiles.map((file) => {
        const storageRef = ref(storage, `serviceImage/${edit.id}/${file.name}`);
        const uploadTask = uploadBytes(storageRef, file);
        promises.push(uploadTask);
      });
      Promise.all(promises);
    }

    handleOnHide();
  };

  const handleOnViewFile = (id, file) => {
    setIsImageLoding(true);
    getDownloadURL(ref(storage, `serviceImage/${id}/${file}`)).then((url) => {
      setFileUrl(url);
      // console.log(url);
    });

    setIsImageLoding(false);
    setCreateModal(true);
  };

  const handleOnHideModal = () => {
    setCreateModal(false);
    setFileUrl(null);
  };

  const handleOnSendMail = async (id) => {
    const ticket = serviceTicketsList.find((item) => item.id === id);
    setDataToSend(ticket);
    setEmailLoading(true);

    try {
      const docRef = collection(db, "accountants");
      const snapshot = await getDocs(docRef);
      const data = [];
      snapshot.forEach((childSnapshot) => {
        data.push({
          ...childSnapshot.data(),
        });
      });
      const list = data
        .filter((item) => item.status === "Available")
        .map((item) => item.email);
      setEmailList(list);
      setSelectEmail(list[0] || "");
      setMailModal(true);
    } catch (error) {
      console.error("Error fetching email list:", error);
    } finally {
      setEmailLoading(false);
    }
  };

  const handleSendSubmit = async (isAll) => {
    if (!selectEmail || !dataToSend.id) {
      console.warn("No email selected or data missing");
      return;
    }

    setEmailLoading(true);

    try {
      const text = {
        to: `${isAll ? emailList : selectEmail}`,
        message: {
          subject: `Service Ticket ${dataToSend.serviceOrderNumber} - ${dataToSend.firstname} ${dataToSend.lastname}`,
          html: `
          <h4>
          <strong>Service Ticket No</strong>: ${
            dataToSend.serviceOrderNumber
          }<br/>
          <strong>Date</strong>: ${new Date(
            dataToSend.date && dataToSend.date.toDate
              ? dataToSend.date.toDate()
              : dataToSend.date || new Date(),
          ).toLocaleString("th-TH", {
            day: "numeric",
            month: "short",
            year: "numeric",
          })}</h4>
          <div style="border:1px solid gray; padding-left:1rem; background-color:#eeeeee;">
            <h5>Customer Information</h5>
            <p><strong>Company HN</strong>: ${dataToSend.hn}<br/>
            <strong>Full Name</strong>: ${dataToSend.firstname} ${
              dataToSend.lastname
            }<br/>
            <strong>Mobile</strong>: ${dataToSend.mobile}
          <br/>
            <strong>Ref Customer</strong>: ${
              dataToSend.refCustomer || "N/A"
            }<br/>
            </div>
          <br>
          <div style="border:1px solid gray; padding-left:1rem; background-color:#eeeeee;">
            <h5>Equipment Information</h5>
            <p><strong>Brand</strong>: ${dataToSend.brand}<br/>
            <strong>Model</strong>: ${dataToSend.model}<br/>
            <strong>Serial Number</strong>: ${dataToSend.sn}<br/>
            </div>
          <br>
          <div style="border:1px solid gray; padding-left:1rem; background-color:#eeeeee;">
            <h5>Service Details</h5>
            <p><strong>Received Date</strong>: ${new Date(
              dataToSend.date,
            ).toLocaleString("th-TH", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })}<br/>
            <strong>Service Type</strong>: ${dataToSend.serviceType}<br/>
            <strong>Received By</strong>: ${dataToSend.receiveBy || "N/A"}<br/>
            <strong>Service Location</strong>: ${
              dataToSend.repairLocation || "N/A"
            }<br/>
            ${
              dataToSend.amount
                ? `<strong>Amount</strong>: ${dataToSend.amount} THB`
                : ""
            }
            ${
              dataToSend.description
                ? `<p><strong>Description</strong>: ${dataToSend.description}</p>`
                : ""
            }
          ${
            dataToSend.serviceDetail
              ? `<p><strong>Service Detail</strong>: ${dataToSend.serviceDetail}</p>`
              : ""
          }
            ${
              dataToSend.completionDate
                ? `<strong>Completion Date</strong>: ${new Date(
                    dataToSend.completionDate.toDate
                      ? dataToSend.completionDate.toDate()
                      : dataToSend.completionDate,
                  ).toLocaleString("th-TH", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })}<br/>`
                : ""
            }
            </p>
          </div>
          <br>

          ${
            dataToSend.note
              ? `<p><strong>Note</strong>: ${dataToSend.note}</p>`
              : ""
          }
          <p><strong>Submitted</strong>: ${currentUser.displayName}</p>
          `,
        },
      };

      await setDoc(doc(collection(db, "mail")), text);
      await updateDoc(doc(db, "serviceTickets", dataToSend.id), {
        isMailSent: true,
        mailSentList: isAll ? emailList : selectEmail,
      });

      setMailModal(false);
      swal("Success", "Email sent successfully!", "success");
    } catch (error) {
      console.error("Error sending email:", error);
      swal("Error", "Failed to send email", "error");
    } finally {
      setEmailLoading(false);
    }
  };

  // External Repair Number Generation
  async function getNextExternalRepairSequence() {
    const sequenceRef = doc(db, "sequenceTracker", "externalRepairSequence");
    const sequenceDoc = await getDoc(sequenceRef);

    const currentDate = new Date();
    const thaiYear = currentDate.getFullYear() + 543;

    if (!sequenceDoc.exists()) {
      // Initialize sequence
      await setDoc(sequenceRef, { current: 1, year: thaiYear });
      return { sequence: "001", year: thaiYear.toString().slice(2) };
    }

    const data = sequenceDoc.data();
    let nextSequence;

    // Reset if year changed
    if (data.year !== thaiYear) {
      nextSequence = 1;
      await setDoc(sequenceRef, { current: 2, year: thaiYear });
    } else {
      nextSequence = data.current + 1;
      await updateDoc(sequenceRef, { current: nextSequence });
    }

    return {
      sequence: nextSequence.toString().padStart(3, "0"),
      year: thaiYear.toString().slice(2),
    };
  }

  async function generateExternalRepairNo() {
    const { sequence, year } = await getNextExternalRepairSequence();
    return "ER" + year + sequence;
  }

  // External Repair handlers
  const handleOpenExternalRepair = (id) => {
    const ticket = serviceTicketsList.find((item) => item.id === id);
    setRepairTicket(ticket);
    // Reset the input ref
    const extRepair =
      ticket && ticket.externalRepair ? ticket.externalRepair : {};
    externalRepairInputRef.current = {
      vendor: extRepair.vendor || "",
      sentDate: extRepair.sentDate || "",
      details: extRepair.details || "",
      notes: extRepair.notes || "",
      repairStatus: extRepair.repairStatus || "",
    };
    setExternalRepairModal(true);
  };

  const handleExternalRepairChange = (name) => (e) => {
    externalRepairInputRef.current[name] = e.target.value;
  };

  const handleExternalRepairSubmit = async (e) => {
    e.preventDefault();

    if (!repairTicket) {
      swal("Error", "No ticket selected", "error");
      return;
    }

    // Validate required fields
    if (!externalRepairInputRef.current.vendor) {
      swal("Error", "กรุณากรอกชื่อบริษัทที่ส่งซ่อม", "error");
      return;
    }
    if (!externalRepairInputRef.current.sentDate) {
      swal("Error", "กรุณากรอกวันที่ส่งบริษัทนอก", "error");
      return;
    }
    if (!externalRepairInputRef.current.repairStatus) {
      swal("Error", "กรุณาเลือกสถานะ", "error");
      return;
    }

    try {
      // Generate external repair number if not exists
      let externalRepairNo =
        repairTicket &&
        repairTicket.externalRepair &&
        repairTicket.externalRepair.externalRepairNo;
      if (!externalRepairNo) {
        externalRepairNo = await generateExternalRepairNo();
      }

      const repairData = {
        hasExternalRepair: true,
        externalRepair: {
          externalRepairNo: externalRepairNo,
          vendor: externalRepairInputRef.current.vendor,
          sentDate: externalRepairInputRef.current.sentDate,
          details: externalRepairInputRef.current.details || "",
          notes: externalRepairInputRef.current.notes || "",
          repairStatus: externalRepairInputRef.current.repairStatus,
          createdAt:
            (repairTicket &&
              repairTicket.externalRepair &&
              repairTicket.externalRepair.createdAt) ||
            new Date(),
          createdBy:
            (repairTicket &&
              repairTicket.externalRepair &&
              repairTicket.externalRepair.createdBy) ||
            currentUser.displayName,
          updatedAt: new Date(),
          updatedBy: currentUser.displayName,
        },
        serviceStatus: "ส่งซ่อมบริษัทนอก",
        updatedAt: new Date(),
        updatedBy: currentUser.displayName,
      };

      await updateDoc(doc(db, "serviceTickets", repairTicket.id), repairData);

      setExternalRepairModal(false);
      swal("Success", "บันทึกข้อมูลส่งซ่อมบริษัทนอกเรียบร้อย", "success");
    } catch (error) {
      console.error("Error saving external repair:", error);
      swal("Error", "Failed to save external repair data", "error");
    }
  };

  const handleCloseExternalRepairModal = () => {
    setExternalRepairModal(false);
    setRepairTicket(null);
    externalRepairInputRef.current = {
      vendor: "",
      sentDate: "",
      details: "",
      notes: "",
      repairStatus: "",
    };
  };

  const handleExportServiceTicket = async (ticketId) => {
    try {
      // console.log("Exporting service ticket:", ticketId);

      // Find the service ticket
      const ticket = serviceTicketsList.find((item) => item.id === ticketId);
      if (!ticket) {
        swal("Error", "Service ticket not found!", "error");
        return;
      }

      // Get patient information
      const patientRef = doc(db, "patients", ticket.hn);
      const patientInfo = await getDoc(patientRef);
      if (!patientInfo.exists()) {
        console.log("No patient document!");
        swal(
          "Warning",
          "Patient information not found. Using ticket data only.",
          "warning",
        );
      }

      // Get booking order number
      let bookingOrder = "";
      try {
        const bookingsQuery = query(
          collectionGroup(db, "bookings"),
          where("extendedProps.hn", "==", ticket.hn),
          orderBy("start", "desc"),
          limit(1),
        );
        const bookingSnapshot = await getDocs(bookingsQuery);

        if (!bookingSnapshot.empty) {
          const bookingData = bookingSnapshot.docs[0].data();
          bookingOrder =
            (bookingData.extendedProps && bookingData.extendedProps.order) ||
            "";
        }
      } catch (error) {
        console.warn("Error fetching booking data:", error);
      }

      // Service template URL
      const serviceTemplateUrl =
        "https://firebasestorage.googleapis.com/v0/b/sleepy-9b23f.firebasestorage.app/o/templates%2FF-501-018-A%20Service%20Request%20Form.pdf?alt=media&token=3425a4f4-cfa6-4ee4-8b94-f0d581037e8c";

      // Load PDF template
      const existingPdfBytes = await fetch(serviceTemplateUrl).then((res) =>
        res.arrayBuffer(),
      );

      // Load font
      const fonturl = "./assets/fonts/Sarabun-Medium.ttf";
      const fontBytes = await fetch(fonturl).then((res) => res.arrayBuffer());

      // Create PDF document
      const pdfDoc = await PDFDocument.load(existingPdfBytes);

      // Register font
      pdfDoc.registerFontkit(fontkit);
      const customFont = await pdfDoc.embedFont(fontBytes, { subset: true });

      // Get page and dimensions
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const { width, height } = firstPage.getSize();

      // Fill PDF fields with service ticket data
      // Service Order Number
      firstPage.drawText(`${ticket.serviceOrderNumber || ""}`, {
        x: 400,
        y: height - 130,
        size: 10,
        font: customFont,
      });

      // Booking Order Number
      if (bookingOrder) {
        firstPage.drawText(`${bookingOrder}`, {
          x: 255,
          y: height - 130,
          size: 10,
          font: customFont,
        });
      }

      // Date
      if (ticket.date) {
        const serviceDate = ticket.date.toDate
          ? ticket.date.toDate()
          : new Date(ticket.date);
        firstPage.drawText(
          serviceDate.toLocaleDateString("th-TH", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }),
          {
            x: 400,
            y: height - 165,
            size: 10,
            font: customFont,
          },
        );
      }

      // Customer Information
      firstPage.drawText(`${ticket.hn || ""}`, {
        x: 180,
        y: height - 130,
        size: 10,
        font: customFont,
      });

      firstPage.drawText(`${ticket.firstname || ""} ${ticket.lastname || ""}`, {
        x: 180,
        y: height - 147,
        size: 10,
        font: customFont,
      });

      // Mobile from patient data or ticket data
      const mobile = patientInfo.exists()
        ? patientInfo.data().mobile
        : ticket.mobile;
      firstPage.drawText(`${mobile || ""}`, {
        x: 180,
        y: height - 165,
        size: 10,
        font: customFont,
      });

      // Address from patient data
      // if (patientInfo.exists()) {
      //   firstPage.drawText(`${patientInfo.data().address1 || ""}`, {
      //     x: 180,
      //     y: height - 260,
      //     size: 10,
      //     font: customFont,
      //   });
      // }

      // Equipment Information
      firstPage.drawText(`${ticket.brand || ""}`, {
        x: 180,
        y: height - 198,
        size: 10,
        font: customFont,
      });

      firstPage.drawText(`${ticket.model || ""}`, {
        x: 400,
        y: height - 198,
        size: 10,
        font: customFont,
      });

      firstPage.drawText(`${ticket.sn || ""}`, {
        x: 180,
        y: height - 217,
        size: 10,
        font: customFont,
      });

      // Service Type
      firstPage.drawText(`${ticket.serviceType || ""}`, {
        x: 400,
        y: height - 147,
        size: 10,
        font: customFont,
      });

      // Problem Description
      if (ticket.description) {
        firstPage.drawText(`${ticket.description}`, {
          x: 100,
          y: height - 305,
          size: 9,
          font: customFont,
          maxWidth: 350,
        });
      }

      // Accessories
      if (ticket.accessories) {
        firstPage.drawText(`${ticket.accessories}`, {
          x: 180,
          y: height - 235,
          size: 9,
          font: customFont,
          maxWidth: 350,
        });
      }

      // Received By
      // firstPage.drawText(`${ticket.receiveBy || ""}`, {
      //   x: 180,
      //   y: height - 520,
      //   size: 10,
      //   font: customFont,
      // });

      // Service Status
      firstPage.drawText(`${ticket.serviceStatus || ""}`, {
        x: 180,
        y: height - 662,
        size: 10,
        font: customFont,
      });

      // Service Details
      if (ticket.serviceDetail) {
        firstPage.drawText(`${ticket.serviceDetail}`, {
          x: 100,
          y: height - 505,
          size: 9,
          font: customFont,
          maxWidth: 350,
        });
      }

      // Service By
      // if (ticket.serviceBy) {
      //   firstPage.drawText(`${ticket.serviceBy}`, {
      //     x: 180,
      //     y: height - 620,
      //     size: 10,
      //     font: customFont,
      //   });
      // }

      // Completion Date
      if (ticket.completionDate) {
        const completionDate = ticket.completionDate.toDate
          ? ticket.completionDate.toDate()
          : new Date(ticket.completionDate);
        firstPage.drawText(
          completionDate.toLocaleDateString("th-TH", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }),
          {
            x: 100,
            y: height - 677,
            size: 10,
            font: customFont,
          },
        );
      }

      // Amount
      // if (ticket.amount) {
      //   firstPage.drawText(`${ticket.amount} THB`, {
      //     x: 180,
      //     y: height - 660,
      //     size: 10,
      //     font: customFont,
      //   });
      // }

      // Note
      // if (ticket.note) {
      //   firstPage.drawText(`${ticket.note}`, {
      //     x: 180,
      //     y: height - 700,
      //     size: 9,
      //     font: customFont,
      //     maxWidth: 350,
      //   });
      // }

      // Generated and Open PDF
      const pdfDocBytes = await pdfDoc.save();
      const pdfUrl = URL.createObjectURL(
        new Blob([pdfDocBytes], { type: "application/pdf" }),
      );
      window.open(pdfUrl, "_blank");

      // console.log("Service ticket PDF generated successfully");
    } catch (error) {
      console.error("Error exporting service ticket PDF:", error);
      swal("Error", "Failed to export PDF. Please try again.", "error");
    }
  };

  return (
    <Fragment>
      <PageTitle
        activeMenu="Service Ticket List"
        motherMenu="Service Tickets"
      />

      <Modal
        className="fade bd-example-modal-lg"
        show={showModal}
        onHide={toggle}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Edit Ticket Datails</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TicketEditForm
            onChange={handleChange}
            initailValues={edit}
            onProductFound={handleProductFound}
            fileNames={fileNames}
            defaultfiles={edit.image}
            ticketId={edit.ticketId}
            onViewFile={handleOnViewFile}
            product={editSearchSerial || edit.sn || ""}
          />

          {/* <div className="form-group row m-1">
            <label className="col-lg-4 col-form-label">รายละเอียดการซ่อม</label>
            <div className="col-lg-6">
              <textarea
                type="textarea"
                className="form-control"
                rows={"3"}
                required
                ref={textRef}
                defaultValue={edit.repairDetail}
              />
            </div>
          </div> */}
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        <div className="d-flex justify-content-center mb-3">
          <Button className="sm" onClick={handleSubmit}>
            Save
          </Button>

          <Button className="sm ml-2" variant="light" onClick={handleOnHide}>
            Cancel
          </Button>
        </div>
      </Modal>

      {!isImageLoding && (
        <Modal
          className="fade bd-example-modal-lg"
          show={createModal}
          onHide={handleOnHideModal}
          size="xl"
          backdrop={true} // Change from "static" to true
          keyboard={true} // Change from false to true
          dialogClassName="modal-90w" // Add this line
        >
          <Modal.Body className="m-0 p-0">
            <div
              className="card-body mx-0 p-0 col-sm-12"
              style={{ height: "80vh" }}
            >
              {fileUrl && (
                <img
                  src={fileUrl}
                  alt="Ticket Image"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain", // Add this line
                  }}
                />
              )}
            </div>
          </Modal.Body>
        </Modal>
      )}

      {/* Email Modal */}
      <Modal show={mailModal} onHide={() => setMailModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Send Email Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group row m-1">
            <label className="col-lg-4 col-form-label">Accountant Email</label>
            <div className="col-lg-6">
              <select
                className="form-control"
                onChange={(e) => setSelectEmail(e.target.value)}
                value={selectEmail}
              >
                <option value="">Select Email...</option>
                {emailList.map((opt, index) => (
                  <option key={index} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="mt-3">
            <strong>Service Ticket Details:</strong>
            <p>
              <strong>Order No:</strong> {dataToSend.serviceOrderNumber}
            </p>
            <p>
              <strong>Patient:</strong> {dataToSend.firstname}{" "}
              {dataToSend.lastname}
            </p>
            <p>
              <strong>HN:</strong> {dataToSend.hn}
            </p>
            <p>
              <strong>Service Type:</strong> {dataToSend.serviceType}
            </p>
            <p>
              <strong>Status:</strong> {dataToSend.serviceStatus}
            </p>
            <p>
              <strong>Equipment:</strong> {dataToSend.brand} {dataToSend.model}{" "}
              (SN: {dataToSend.sn})
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        <div className="d-flex justify-content-between mb-3 mx-3">
          <Button className="sm" onClick={() => handleSendSubmit(true)}>
            Send All
          </Button>
          <div>
            <Button className="sm" onClick={() => handleSendSubmit(false)}>
              Send
            </Button>
            <Button
              className="sm ml-2"
              variant="light"
              onClick={() => setMailModal(false)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>

      {/* External Repair Modal */}
      <Modal
        show={externalRepairModal}
        onHide={handleCloseExternalRepairModal}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>ส่งซ่อมบริษัทนอก</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {repairTicket && (
            <div className="mb-3 p-3 bg-light rounded">
              <p className="mb-1">
                <strong>Service Order:</strong>{" "}
                {repairTicket.serviceOrderNumber}
              </p>
              <p className="mb-1">
                <strong>Customer:</strong> {repairTicket.firstname}{" "}
                {repairTicket.lastname}
              </p>
              <p className="mb-0">
                <strong>Equipment:</strong> {repairTicket.brand}{" "}
                {repairTicket.model} (SN: {repairTicket.sn})
              </p>
            </div>
          )}

          {/* Service Type from ticket */}
          {repairTicket && repairTicket.serviceType && (
            <div className="form-group row m-1">
              <label className="col-lg-4 col-form-label">ประเภท</label>
              <div className="col-lg-6">
                <input
                  type="text"
                  className="form-control"
                  value={repairTicket.serviceType}
                  disabled
                />
              </div>
            </div>
          )}

          {/* Accessories from ticket */}
          {repairTicket && repairTicket.accessories && (
            <div className="form-group row m-1">
              <label className="col-lg-4 col-form-label">รายการอุปกรณ์</label>
              <div className="col-lg-6">
                <textarea
                  className="form-control"
                  value={repairTicket.accessories}
                  disabled
                  rows="2"
                />
              </div>
            </div>
          )}

          {/* Images from ticket */}
          {repairTicket &&
            repairTicket.image &&
            repairTicket.image.length > 0 && (
              <div className="form-group row m-1">
                <label className="col-lg-4 col-form-label">รูปภาพ</label>
                <div className="col-lg-6">
                  {repairTicket.image.map((img, idx) => (
                    <Link
                      key={idx}
                      to="#"
                      onClick={() => handleOnViewFile(repairTicket.id, img)}
                      className="mr-2 d-block"
                    >
                      <i className="fa fa-image"></i> {img}
                    </Link>
                  ))}
                </div>
              </div>
            )}

          <ExternalRepairForm
            onChange={handleExternalRepairChange}
            initialValues={repairTicket && repairTicket.externalRepair}
          />
        </Modal.Body>
        <div className="d-flex justify-content-center mb-3">
          <Button className="sm" onClick={handleExternalRepairSubmit}>
            บันทึก
          </Button>
          <Button
            className="sm ml-2"
            variant="light"
            onClick={handleCloseExternalRepairModal}
          >
            ยกเลิก
          </Button>
        </div>
      </Modal>

      <div className="form-head d-flex mb-3 mb-lg-5 align-items-start">
        <Link
          to="/service-ticket-create"
          className="btn btn-danger"
          data-toggle="tooltip"
          data-placement="top"
          title="Create Ticket"
        >
          + New Ticket
        </Link>

        <div className="input-group search-area ml-auto d-inline-flex">
          <input
            type="text"
            className="form-control"
            placeholder="Search serial number here"
            ref={searchRef}
            onChange={onSearchChange}
          />
          <div className="input-group-append">
            <span className="input-group-text c-pointer">
              <i className="flaticon-381-search-2"></i>
            </span>
          </div>
        </div>
      </div>
      {/* <p className="text-danger">Under Testing</p> */}
      {/* <span className="text-danger">
          *กรุณา Register อุปกรณ์ก่อนสร้าง Ticket หากอุปกรณ์ยังไม่มีอยู่ในระบบ
      </span> */}
      <TicketItem
        tickets={serviceTicketsList}
        onEdit={handleOnEdit}
        onViewFile={handleOnViewFile}
        onDelete={handleOnDelete}
        onSendMail={handleOnSendMail}
        onExportTicket={handleExportServiceTicket}
        onExternalRepair={handleOpenExternalRepair}
        // onNext={!isEnd && getNext}
        // onPrev={!isStart && getPrev}
        totalItems={totalItems}
        totalPages={totalPages}
        currentPage={currentPage}
        itemsPerPage={itemPerPage}
        goToPage={goToPage} //pass goToPage
        isStart={isStart} //pass isStart
        isEnd={isEnd} //pass isEnd
        getNext={getNext} //pass getNext
        getPrev={getPrev} //pass getPrev
      />
    </Fragment>
  );
};

export default TicketList;
